export default __webpack_public_path__ + "static/media/masha.e2f31b17.png";